// JS for handling Gated Pop Up
const gatedPopUpTriggers = document.querySelectorAll('.js-gated-pop-up__trigger');
const gatedPopUps = document.querySelectorAll('.js-gated-pop-up');

const gatedPopUpCloseButton = document.querySelectorAll('.js-gated-pop-up__close-button');
const gatedPopUpCookieButton = document.querySelectorAll('.js-gated-pop-up__cookie-btn');
const gatedPopUpSubscribeButton = document.querySelector(
  ".js-gated-pop-up__subscribe"
);

const emailInputErrorMessage = document.querySelector(
  ".twc-gated-pop-up__email-error-message"
);

const formSubmitBtns = document.querySelectorAll('input[id="mc-embedded-subscribe"]');
const focusableElementTargets = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const firstNameInput = document.getElementById("mce-FNAME");
const lastNameInput = document.getElementById("mce-LNAME");
const emailInput = document.getElementById("mce-EMAIL");
const gatedPopUpForm = document.getElementById("mce-FORM");

const body = document.querySelector('body');

let gatedPopUpIsOpen = false;
let pdf = "";

function handleToggleGatedPopUp(gatedPopUp) {
    if (!gatedPopUp) return;
    // Show or hide Gated Pop Up onClick
    if (gatedPopUp.classList.contains('active-gated-pop-up')) {
        gatedPopUp.classList.remove('active-gated-pop-up');
        // this.closest(".js-gated-pop-up__trigger").focus();
        // When the gated pop up is hidden, we want to remove overflow-hidden on body
        body.classList.remove("tw-overflow-hidden");
        gatedPopUpIsOpen = false;
    } else {
        gatedPopUp.classList.add('active-gated-pop-up');
        pdf = gatedPopUp.getAttribute('data-js-pop-pdf');
        // Keep focus to "X" icon button when pop up is open
        gatedPopUpCloseButton[0].focus();
        // When the gated pop up is shown, we want to add overflow-hidden class to body to prevent scrolling outside pop up
        body.classList.add("tw-overflow-hidden");
        gatedPopUpIsOpen = true;
    }
}

function closeGatedPopup(gatedPopUp) {
    if (!gatedPopUp) return;
    if (gatedPopUp.classList.contains('active-gated-pop-up')) {
        gatedPopUp.classList.remove('active-gated-pop-up');
        // gatedPopUp.closest(".js-gated-pop-up__trigger").focus();
        // When the gated pop up is hidden, we want to remove overflow-hidden on body
        body.classList.remove("tw-overflow-hidden");
        gatedPopUpIsOpen = false;
    }
}

// Trap keyboard focus inside the modal
function handleGatedPopUpListeners(popUp) {

    let focusable = popUp.querySelectorAll(focusableElementTargets);
    let firstFocusableElement = focusable[0];
    let lastFocusableElement = focusable[focusable.length - 1];

    popUp.addEventListener('keydown', function (e) {
        if (gatedPopUpIsOpen) {
            if (e.key == 'Tab') {
                if (!e.shiftKey) {
                    if (document.activeElement == lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement == firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }
    
            if (e.key == 'Escape') {
                closeGatedPopup(popUp);
            }
        }
    });
}

function disableBtn() {
    this.classList.add("disabled");

  // Add 3 second undo for when user hits HTML validation (like invalid email)
  setTimeout(() => {
    this.classList.remove('disabled');
  }, 3000);
}

/*-------------------------------------------
  Cookie Functions
-------------------------------------------*/

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

function checkCookieOnLoad() {
   if(readCookie("gated_pop_up_posted_databook") === "yes") {
        return true;
    } else {
        return false;
   }
}


// Listen for submit & dismiss button events here
function handleGatedPopUpCookieButtonListeners(popUp) {
    gatedPopUpCookieButton.forEach((button) => {
        button.addEventListener("click", function (e) {
            // e.preventDefault();
            createCookie("gated_pop_up_posted_databook", "yes");
            closeGatedPopup(popUp);
        });
    });
}

function main() {
    if(gatedPopUps){
        gatedPopUps.forEach((popup) => {
            gatedPopUpSubscribeButton.disabled = true;
            const gatedPopUpsEnabled = popup ? popup.getAttribute('data-js-pop-up-enabled') : null;
            checkCookieOnLoad();
            handleGatedPopUpListeners(popup);

            // When the user clicks anywhere outside of the gated pop up content container, close it
            window.onclick = function(event) {
                if (event.target == popup.querySelector('.twc-gated-pop-up__container')) {
                    closeGatedPopup(popup);
                }
            }
            if(formSubmitBtns) {
                formSubmitBtns.forEach( btn => {
                    btn.addEventListener("click", disableBtn);
                })
            }
            if (emailInput) {
                // Add input event listener to emailInput field to validate email field value & enable/disable submit button
                emailInput.addEventListener("input", (e) => {
                    var emailRegex =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (emailRegex.test(e.target.value)) {
                        gatedPopUpSubscribeButton.disabled = false;
                        gatedPopUpSubscribeButton.classList.remove('tw-cursor-none');
                        if (!emailInputErrorMessage.classList.contains("tw-hidden")) {
                            emailInputErrorMessage.classList.add("tw-hidden");
                        }
                        } else {
                        emailInputErrorMessage.classList.remove(
                          "tw-hidden"
                        );
                        gatedPopUpSubscribeButton.disabled = true;
                    }
                });
            }
            if (gatedPopUpTriggers) {
                gatedPopUpTriggers.forEach((trigger) => {
                    const gatedPopUpPDFURL = trigger ? trigger.getAttribute('data-js-filepath') : null;

                    trigger.addEventListener('click', function (e) {
                        e.preventDefault();
                        popup.setAttribute('data-js-pop-pdf', gatedPopUpPDFURL);
                        if(checkCookieOnLoad() || !gatedPopUpsEnabled) {
                            window.open(gatedPopUpPDFURL, '_blank');
                        } else {
                            handleToggleGatedPopUp(popup);
                        }
                    });
                });
            }
            if (gatedPopUpCloseButton) {
                gatedPopUpCloseButton.forEach(button => {
                    button.addEventListener('click', function (e) {
                        e.preventDefault();
                        closeGatedPopup(popup);
                    });
                });
            }
            // handleSubmitBtnListener(popup);
            handleGatedPopUpCookieButtonListeners(popup);
        });
    }
}

export default function () {
    main();
}
